__turbopack_context__.v({
  "header": "index-module__pK_bSW__header",
  "main": "index-module__pK_bSW__main",
  "root": "index-module__pK_bSW__root",
});
